// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3qnRK","footer":"ModalError_footer__DCJOf"};